import {ENDPOINT_ADMIN_ARBITRAGE_DEPOSITS_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const loopMap = require('mn-utils/loopMap');
const {
  apiRequestAdmin,
} = require('../ws');


const MOCK_ARBITRAGE_DEPOSITS = loopMap(100, (i) => {
  const id = '' + (1 + i);
  return {
    id: '24286723-46435-43545-3454423-2343' + id,
    login: 'example_user@example.com',
    created_at: '2020-02-17T12:07:45',
    sc_code: 'EURS',
    sc_amount: 120.29123 + id,
  };
});

export function apiAdminArbitrageDepositsList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {
      list: MOCK_ARBITRAGE_DEPOSITS.slice(offset, offset + limit),
      count: MOCK_ARBITRAGE_DEPOSITS.length,
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_ARBITRAGE_DEPOSITS_LIST, {
    ...params,
    offset,
    limit,
  });
}
